import { render, staticRenderFns } from "./TradeEdit.vue?vue&type=template&id=ebc03326&"
import script from "./TradeEdit.vue?vue&type=script&lang=js&"
export * from "./TradeEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports